import { render, staticRenderFns } from "./products9A-classes-input.vue?vue&type=template&id=9c299bbe&"
import script from "./products9A-classes-input.vue?vue&type=script&lang=js&"
export * from "./products9A-classes-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports